import { createI18n } from 'vue-i18n'
import en from './locales/en.json'
import cy from './locales/cy.json'
import store from '../../store/store'//'@/store/store'

const savedLocale = store.state.selectedLanguage || 'en'



export const i18n = createI18n({
  legacy: false,
  locale: savedLocale,
  fallbackLocale: 'en',
  messages: {
    en,
    cy
  }
})